module.exports = __webpack_public_path__ + "static/img/1.bb4a2260.png";